import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

const initMemberTestimonialsSwiper = () => {
  let memberTestimonials = new Swiper(".testimonial-slider .swiper-container", {
    loop: true,
    pagination: ".swiper-pagination",
    paginationClickable: true,
    autoHeight: true,
    autoplay: 10000,
  });
};

const initTestimonials = () => {
  let testimonials = new Swiper(".testimonials .swiper-container", {
    autoplay: 10000,
    init: false,
    autoHeight: true,
    effect: 'fade',
    pagination: ".testimonials__footer .testimonials__bullets",
    paginationType: "bullets",
    nextButton: ".testimonials__footer .testimonials__next",
    prevButton: ".testimonials__footer .testimonials__prev",
  });

  function updateNextPrevLabels(swiper) {
    var container = $(swiper.container),
      prev = container.find(".testimonials__prev span"),
      next = container.find(".testimonials__next span");

    prev.text(container.find(".swiper-slide-active").prev().data("author"));
    next.text(container.find(".swiper-slide-active").next().data("author"));
  }

  testimonials.on("init", updateNextPrevLabels);
  testimonials.on("slideChangeStart", updateNextPrevLabels);

  testimonials.init();
};

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".testimonial-slider")) {
    initMemberTestimonialsSwiper();
  }

  if (document.querySelector(".testimonials .swiper-container")) {
    initTestimonials();
  }
});
